var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 15.4168C12.9902 15.4168 15.4154 12.9917 15.4154 10.0002C15.4154 7.00862 12.9902 4.5835 9.9987 4.5835C7.00716 4.5835 4.58203 7.00862 4.58203 10.0002C4.58203 12.9917 7.00716 15.4168 9.9987 15.4168Z",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9513 15.9498L15.843 15.8415M15.843 4.15817L15.9513 4.04984L15.843 4.15817ZM4.0513 15.9498L4.15964 15.8415L4.0513 15.9498ZM10.0013 1.73317V1.6665V1.73317ZM10.0013 18.3332V18.2665V18.3332ZM1.73464 9.99984H1.66797H1.73464ZM18.3346 9.99984H18.268H18.3346ZM4.15964 4.15817L4.0513 4.04984L4.15964 4.15817Z",
    stroke: "#575757",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.295e692b9862c95dff6528b3ce811d4a.svg";
export { ForwardRef as ReactComponent };